/** 银行列表常量 — 用于专家登记表单"收款银行"下拉选择 */
export const BANK_LIST: string[] = [
    '中国工商银行',
    '中国农业银行',
    '中国银行',
    '中国建设银行',
    '中国农业发展银行',
    '中信银行',
    '中国光大银行',
    '交通银行',
    '上海浦东发展银行',
    '兴业银行',
    '招商银行',
    '平安银行',
    '华夏银行',
    '中国民生银行',
    '广发银行',
    '苏州银行',
    '宁波东海银行',
    '宁波银行',
    '宁波通商银行',
    '温州银行',
    '嘉兴银行',
    '湖州银行',
    '浙江稠州商业银行',
    '绍兴银行',
    '金华银行',
    '龙江银行',
    '吉林银行',
    '南京银行',
    '江苏银行',
    '江苏长江商业银行',
    '哈尔滨银行',
    '杭州银行',
    '天津银行',
    '保定银行',
    '蒙商银行',
    '鞍山银行',
    '抚顺银行',
    '丹东银行',
    '锦州银行',
    '葫芦岛银行',
    '营口银行',
    '营口沿海银行',
    '阜新银行',
    '辽阳银行',
    '朝阳银行',
    '张家口银行',
    '承德银行',
    '乌海银行',
    '沧州银行',
    '廊坊银行',
    '衡水银行',
    '晋商银行',
    '鄂尔多斯银行',
    '河北银行',
    '北京银行',
    '唐山银行',
    '盛京银行',
    '秦皇岛银行',
    '邯郸银行',
    '内蒙古银行',
    '大连银行',
    '邢台银行',
    '石嘴山银行',
    '乌鲁木齐银行',
    '昆仑银行',
    '哈密市商业银行',
    '库尔勒银行',
    '新疆汇和银行',
    '天津滨海农村商业银行',
    '长安银行',
    '东莞银行',
    '广西北部湾银行',
    '自贡银行',
    '泸州银行',
    '贵阳银行',
    '贵州银行',
    '柳州银行',
    '长城华西银行',
    '绵阳市商业银行',
    '兰州银行',
    '桂林银行',
    '遂宁银行',
    '甘肃银行',
    '乐山市商业银行',
    '宜宾市商业银行',
    '富滇银行运营',
    '曲靖市商业银行',
    '云南红塔银行',
    '青海银行',
    '四川天府银行',
    '西藏银行',
    '西安银行',
    '宁夏银行',
    '成都银行',
    '重庆银行',
    '达州银行',
    '雅安市商业银行',
    '威海市商业银行',
    '焦作中旅银行',
    '华融湘江银行',
    '长沙银行',
    '广州银行',
    '珠海华润银行',
    '广东华兴银行',
    '广东南粤银行',
    '台州银行',
    '齐鲁银行',
    '德州银行',
    '浙江泰隆商业银行',
    '浙江民泰商业银行',
    '青岛银行',
    '临商银行',
    '日照银行',
    '福建海峡银行',
    '齐商银行',
    '厦门银行',
    '郑州银行',
    '泉州银行',
    '枣庄银行',
    '东营银行',
    '烟台银行',
    '汉口银行',
    '江西银行',
    '潍坊银行',
    '洛阳银行',
    '平顶山银行',
    '湖北银行',
    '九江银行',
    '济宁银行',
    '赣州银行',
    '泰安银行',
    '莱商银行',
    '上饶银行',
    '天津农村商业银行',
    '渤海银行',
    '徽商银行',
    '海口联合农村商业银行',
    '成都农商银行',
    '重庆农村商业银行',
    '恒丰银行',
    '广州农村商业银行',
    '浙商银行',
    '广东顺德农村商业银行',
    '无锡农村商业银行',
    '江苏江阴农村商业银行',
    '江苏江南农村商业银行',
    '太仓农村商业银行',
    '昆山农村商业银行',
    '苏州农村商业银行',
    '江苏常熟农村商业银行',
    '张家港农村商业银行',
    '河北省农村信用社联合社',
    '北京农村商业银行',
    '长葛轩辕村镇银行有限责任公司',
    '重庆三峡银行',
    '上海农商银行',
    '内蒙古自治区农村信用社联合社',
    '辽宁省农村信用社联合社运营',
    '山西省农村信用社联合社',
    '安徽省农村信用社联合社',
    '宁波鄞州农村商业银行(鄞州银行)',
    '江苏省农村信用社联合社',
    '浙江省农村信用社联合社',
    '黑龙江省农村信用社联合社',
    '吉林省农村信用社联合社',
    '山东省农村信用社联合社',
    '江西省农村信用社联合社',
    '福建省农村信用社联合社',
    '湖南省农村信用社联合社',
    '河南省农村信用社联合社',
    '湖北省农村信用社联合社',
    '武汉农村商业银行',
    '云南省农村信用社联合社',
    '陕西省农村信用社联合社',
    '广东省农村信用社联合社',
    '东莞农村商业银行',
    '四川省农村信用社联合社',
    '广西壮族自治区农村信用社联合社',
    '深圳农村商业银行',
    '海南省农村信用社联合社',
    '贵州省农村信用社联合社',
    '中国邮政储蓄银行',
    '新疆维吾尔自治区农村信用社联合社',
    '宁夏黄河农村商业银行',
    '青海省农村信用社',
    '汇丰银行(中国)有限公司',
    '深圳前海微众银行',
    '东亚银行（中国）有限公司',
    '南洋商业银行（中国）有限公司',
    '恒生银行(中国)有限公司上海分行',
    '大新银行（中国）有限公司',
    '花旗银行(中国)有限公司',
    '友利银行(中国)有限公司',
    '新韩银行(中国)有限公司',
    '韩亚银行(中国)有限公司',
    '渣打银行（中国）有限公司上海分行',
    '中德住房储蓄银行',
    '厦门国际银行',
    '富邦华一银行有限公司',
    '中原银行',
    '上海华瑞银行',
    '温州民商银行',
    '天津金城银行',
    '海南银行',
    '上海银行',
    '浙江网商银行',
    '创兴银行有限公司广州分行',
    '玉山银行（中国）有限公司',
    '福建华通银行',
    '新疆银行',
    '重庆富民银行',
    '湖南三湘银行',
    '中信百信银行',
    '武汉众邦银行',
    '辽宁振兴银行',
    '四川新网银行',
    '江苏苏宁银行',
    '吉林亿联银行',
    '北京中关村银行',
    '大连农村商业银行',
    '威海蓝海银行',
    '安徽新安银行',
    '江西裕民银行',
    '辽沈银行',
    '四川银行',
    '山西银行',
];
